import { getDataType, getDimensions, getMetrics, getReportConfig } from 'reporting-data/report/configReportGetters';
import { getReportChartType } from 'reporting-data/report/reportGetters';
import { getOrConvertToObjectTypeId } from 'reporting-data/crmObjects/tsUtils';
import { STANDARD_FIELD_TYPES } from './shared/constants/fieldTypes';
export const ConfigReportGetterStrategy = {
  [STANDARD_FIELD_TYPES.DIMENSIONS]: report => {
    const dataType = getDataType(report);
    return getDimensions(report).toJS().map(dim => ({
      property: dim,
      dataType
    }));
  },
  [STANDARD_FIELD_TYPES.METRICS]: report => {
    const dataType = getDataType(report);
    return getMetrics(report).map(metric => {
      var _metric$get, _metric$get2;
      const percentile = (_metric$get = metric.get('percentiles')) === null || _metric$get === void 0 ? void 0 : _metric$get.first();
      return Object.assign({
        property: metric.get('property'),
        metricType: (_metric$get2 = metric.get('metricTypes')) === null || _metric$get2 === void 0 ? void 0 : _metric$get2.first()
      }, percentile ? {
        percentiles: [percentile]
      } : {}, {
        dataType
      });
    }).toJS();
  },
  [STANDARD_FIELD_TYPES.DATA_TYPE]: report => getDataType(report),
  [STANDARD_FIELD_TYPES.CHART_TYPE]: report => getReportChartType(report),
  [STANDARD_FIELD_TYPES.PRIMARY_DATA_SOURCE_ID]: report => getOrConvertToObjectTypeId(getReportConfig(report)),
  [STANDARD_FIELD_TYPES.ALL_DATA_SOURCE_IDS]: report => {
    const dataSourceId = getOrConvertToObjectTypeId(getReportConfig(report));
    return dataSourceId ? [dataSourceId] : [];
  }
};